import { render, staticRenderFns } from "./archive.vue?vue&type=template&id=7d0da24a&"
import script from "./archive.vue?vue&type=script&lang=js&"
export * from "./archive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d0da24a')) {
      api.createRecord('7d0da24a', component.options)
    } else {
      api.reload('7d0da24a', component.options)
    }
    module.hot.accept("./archive.vue?vue&type=template&id=7d0da24a&", function () {
      api.rerender('7d0da24a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/repair/repairManagement/archive.vue"
export default component.exports